'use client';

import { createContext, type ReactNode } from 'react';
import type { BranchId } from '@/shared/config/funnel/constants';
import type { FlattenedFunnelConfig } from '@/shared/config/funnel/flattened/types';
import type { FunnelStepSnapshot } from '../stepSnapshot';

export type FunnelStepContextValue = {
  funnelFlattenedConfig: FlattenedFunnelConfig;
  stepId: string;
  branchId: BranchId | null;
  isFirstStep: boolean;
  isBranchFirstStep: boolean;
  isBranchLastStep: boolean;
  progress: number;
  funnelConfigVersion: string;
};

export const FunnelStepContext = createContext<FunnelStepContextValue | undefined>(undefined);

type FunnelStepProviderProps = {
  children: ReactNode;
  funnelFlattenedConfig: FlattenedFunnelConfig;
  stepSnapshot: FunnelStepSnapshot;
  branchId: BranchId | null;
  funnelConfigVersion: string;
};

export function FunnelStepProvider({
  children,
  funnelFlattenedConfig,
  stepSnapshot,
  branchId,
  funnelConfigVersion,
}: FunnelStepProviderProps) {
  const { stepId, isFirstStep, isBranchFirstStep, isBranchLastStep, progress } = stepSnapshot;
  const value: FunnelStepContextValue = {
    funnelFlattenedConfig,
    stepId,
    branchId,
    isFirstStep,
    isBranchFirstStep,
    isBranchLastStep,
    progress,
    funnelConfigVersion,
  };

  return <FunnelStepContext.Provider value={value}>{children}</FunnelStepContext.Provider>;
}
